import { useSelector } from "react-redux";
import type { RootState } from "../../app/store";
import { isMasterAdmin } from "../../utils/isMasterAdmin";
import { wizardStepAccess, type WizardStepAccess } from "./wizardPermissions";
import type { StepKey } from "./wizardSteps";

/** What the signed-in user may do on one wizard page. */
export default function useWizardStepAccess(step: StepKey): WizardStepAccess {
  const userLogged = useSelector((state: RootState) => state.home.userLogged);
  const permissionSet = useSelector((state: RootState) => state.user.permissionSet);

  return wizardStepAccess(step, permissionSet ?? [], isMasterAdmin(userLogged));
}
